import React from "react";
import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";

const labels = ["اسفند", "بهمن", "دی", "اذر", "ابان", "مهر"];

const data = {
  labels: labels,
  datasets: [
    {
      label: "ارجاع 40%",
      backgroundColor: "#35C07D",
      borderColor: "#35C07D",
      data: [0, 10, 5, 2, 20, 30, 45],
    },
  ],
};

const LineChart = () => {
  return (
    <div>
      <Line data={data} />
    </div>
  );
};

export default LineChart;